'use client'

import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

const labelVariants = cva(
  'typo-label1 flex items-center gap-0.5 text-black peer-disabled:cursor-default',
  {
    variants: {
      bold: {
        true: 'font-medium',
      },
    },
  },
)

export type Props = ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & {
    required?: boolean
    optional?: boolean
  }

const Label = ({
  className,
  bold = false,
  required = false,
  optional = false,
  children,
  ...props
}: Props) => {
  const t = useTranslations('common')

  return (
    <LabelPrimitive.Root
      className={cn(labelVariants({ bold, className }))}
      {...props}
    >
      {children}
      {required && <span className="typo-caption1 text-red-500">*</span>}
      {optional && (
        <span className="typo-caption1 text-gray-500">
          {t('form.label_optional')}
        </span>
      )}
    </LabelPrimitive.Root>
  )
}

export { Label }
